import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Grid from '@ublique/components/Template/components/Grid'
import UbliqueRow from '@ublique/components/Template/components//Row'
import UbliqueColumn from '@ublique/components/Template/components//Column'
import UbliqueContainer from '@ublique/components/Template/components/Container'

import './index.scss'
import StripePageOvsTitle from './stripes/StripePageOvsTitle'

const PageCustomOvs = ({ title, className, children, configMenu }) => {
  return (
    <UbliqueContainer>
      <Grid className={cn('ublique-page', className)}>
        {title && <StripePageOvsTitle text={title} configMenu={configMenu} />}
        {children}
      </Grid>
    </UbliqueContainer>
  )
}

PageCustomOvs.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.array,
  configMenu: PropTypes.object
}

PageCustomOvs.defaultProps = {
  title: ''
}

export { UbliqueRow, UbliqueColumn, PageCustomOvs as default }
